module.exports = __webpack_public_path__ + "static/img/17.96be026.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/17.png
// module id = kBzB
// module chunks = 5